const initState = {
    appTitle: '\tAssetTag',
    appDescription: 'Create Record Manage',

    themeColor: "#143896",
    // themeColorNav: "linear-gradient(rgba(6, 23, 104, 1),rgba(18, 50, 142, 1))",
    themeColorNav: "linear-gradient(rgba(5, 19, 91, 1), rgba(18, 50, 142, 1))",
    themeColorTrans: "rgba(22, 22, 22, 0.2)",
    themeColorArray: [
        'rgb(227, 227, 227)',
        'rgb(186, 186, 186)',
        'rgb(140, 140, 140)',
        'rgb(94, 94, 94)',
        'rgb(60, 60, 60)',
        'rgb(25, 25, 25)',
        'rgb(22, 22, 22)',
        'rgb(18, 18, 18)',
        'rgb(14, 14, 14)',
        'rgb(8, 8, 8)',
        'rgb(255, 80, 80)',
        'rgb(255, 29, 29)',
        'rgb(233, 0, 0)',
        'rgb(207, 0, 0)',
    ],

    // MAIN COLORS
    themeHoverColor: "#061768",  //"rgba(169, 2, 62, 1)",
    themeActiveColor: "#061768",
    darkThemeColor: "#061768",
    themeSecColor: "darkred",
    backgroundColor: "#fafafa",
    invisibleColor: "transparent",

    // SPECIAL COLORS
    cardHeaderColor: "rgba(255, 255, 255, 1)",

    // BUTTON COLORS
    buttonColor: "#061768",//"#161616",
    buttonHoverColor: "#061768",
    firstButtonColor: "#061768",
    firstButtonHoverColor: "#061768",
    secondButtonColor: "#061768",
    secondButtonHoverColor: "#061768",
}

const themeReducer = (state = initState, action) => {
    return state;
}

export default themeReducer;